/* src/app/account/account-allocations/account-allocations/account-allocations.component.scss */
/*# sourceMappingURL=account-allocations.component.css.map */
